export function renderIf (component, condition) {
    if (condition) {
      return component;
    }
    return null;
}
